<section>
  <app-content-container>
    <div
      class="flex flex-col items-center xl:flex-row xl:justify-center xl:gap-24"
    >
      <div class="w-full max-w-[500px]">
        <app-angular-monolith></app-angular-monolith>
      </div>

      <div class="flex flex-col items-center max-w-[560px]">
        <h3 class="w-full section-title text-center">
          Somos a primeira plataforma do Brasil focada em
          <span class="angular-font-color">Angular</span>!
        </h3>

        <p class="section-description text-center mt-8">
          Nosso objetivo é enriquecer o mercado de desenvolvimento
          <span class="angular-font-color">Angular</span> no Brasil,
          proporcionando cursos e treinamentos de qualidade para todos os nossos
          alunos.
        </p>

        <button
          class="btn btn-primary w-full max-w-[300px] mt-8"
          [appScrollTo]="'courses-section'"
        >
          Confira nossos cursos!
        </button>
      </div>
    </div>
  </app-content-container>
</section>
